import { ProductPreviewCard } from '@/widgets/product-preview-card/ui/ProductPreviewCard';

export { ProductPreviewCard };
